export default __webpack_public_path__ + "static/media/sitting-bear.479c69ae.svg";